<template>
  <div>
    <form class="form">
      <div class="fieldSet">
        <h3 v-if="bubbleTitle">{{bubbleTitle}}</h3>
        <div class="field">
          <label>{{$t('profile.name')}}</label>
          <input v-model="updateUserInformation.name" type="text" name="" :disabled="!allowUpdate">
          <ErrorMessage v-if="updateUserErrors.errors?.name !== undefined">{{$t('errors.invalidPassword')}}</ErrorMessage>
        </div>
        <div class="field">
          <label>{{$t('profile.surname')}}</label>
          <input v-model="updateUserInformation.surname" type="text" name="" :disabled="!allowUpdate">
          <ErrorMessage v-if="updateUserErrors.errors?.surname !== undefined">{{$t('errors.fieldIsRequired')}}</ErrorMessage>
        </div>
        <div class="field">
          <label>{{$t('profile.email')}}</label>
          <input v-model="updateUserInformation.email" type="text" name="" :disabled="!allowUpdate">
          <ErrorMessage v-if="updateUserErrors.errors?.email !== undefined">{{$t('errors.invalidEmail')}}</ErrorMessage>
        </div>
        <div v-if="allowUpdate">
          <a href="#" class="bt btG" @click.prevent="allowUpdate = false">{{$t('profile.cancel')}}</a>
          <a href="#" class="bt" @click="save">{{$t('profile.confirm')}}<i class="fa fa-check"/></a>
        </div>
        <a v-else href="#" class="bt btG" @click.prevent="allowUpdate = true">{{$t('profile.update')}}</a>
      </div>
    </form>
    <toast ref="toastMessage">{{$t('profile.dataUpdated')}}</toast>
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import type {UpdateUserDataErrors, UpdateUserInformationRequest} from "~/api/generated";
import api from "~/api";

const updateUserInformation = ref<UpdateUserInformationRequest>({
  name: '',
  surname: '',
  email: ''
})
const allowUpdate = ref(false)
const updateUserErrors = ref<UpdateUserDataErrors>({})
const toastMessage = ref(null)
defineProps({
  bubbleTitle: String,
})

onMounted(async ()=>{
  const apiResponse = await api.User.getUserInfo()
  updateUserInformation.value = apiResponse.data as UpdateUserInformationRequest
})

async function save() {
  try {
    await api.User.updateUserInfo(updateUserInformation.value)
    toastMessage.value?.activate(1.5)
  } catch (error: AxiosError) {
    if (error.response.status === 422) {
      updateUserErrors.value = error.response.data
    }
  }
}
</script>
